import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// react-icons
import { MdKeyboardArrowDown } from 'react-icons/md'

// image
import IconProfileImage from '../../../images/components/topnav/icon_profile.svg';

function NavItem({ menu, subMenuList}) {
    const navItemRef = useRef(null);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [openSubMenu, setOpenSubMenu] = useState(false);

    const handleClickMenu = () => {
        if(subMenuList.length === 0){
            navigate(menu.link);
        }else {
            setOpenSubMenu(!openSubMenu);
        }
    }

    const handleClickWindow = (e) => {
        if(!navItemRef.current.contains(e.target)){
            setOpenSubMenu(false);
        }
    }

    useEffect(()=>{
        window.addEventListener("click", handleClickWindow);
    
        return () => {
            window.removeEventListener("click", handleClickWindow);
        }
    },[])

    return (
        <div
            className='NavItem'
            ref={navItemRef}
            onClick={handleClickMenu}
        >
            <div className='NavItem-Menu'>
                {menu.link==="/mypage" && <img className='ProfileIcon' src={IconProfileImage} alt='profile icon' />}
                <div className='Menu-Title'>                    
                    {menu.name}
                    {pathname.includes(menu.link) &&
                        <div className='UnderLine' />
                    }
                </div>
                {subMenuList.length>0 && <MdKeyboardArrowDown />}
            </div>
            {openSubMenu && subMenuList.length>0 &&
            <div className='NavItem-SubMenu'>
                {subMenuList.map(subMenu =>
                    <div
                        key={subMenu.name}
                        className={`SubMenuItem ${pathname.includes(subMenu.link) ? "SubMenuItem-Selected" : ""}`}
                        onClick={()=>navigate(subMenu.link)}
                    >
                        {subMenu.name}
                    </div>
                )} 
            </div>}
        </div>
    );
}

export default NavItem;